/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetApiV3ImagesCanistersCanisterIdPng } from "../../funcs/imagesGetApiV3ImagesCanistersCanisterIdPng.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3ImagesCanistersCanisterIdPngRequest$inboundSchema,
};

export const tool$imagesGetApiV3ImagesCanistersCanisterIdPng: ToolDefinition<
  typeof args
> = {
  name: "images-get-api-v3-images-canisters-canister-id-png",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await imagesGetApiV3ImagesCanistersCanisterIdPng(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
